import React from 'react';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'recipient', label: 'Destinataire' },
  { id: 'sender', label: 'Expéditeur' },
  { id: 'adress', label: 'Adresse' },
  { id: 'status', label: 'État de la commande' },
  { id: 'trackingNumber', label: 'Numéro de suivi' },
  { id: 'carrier', label: 'Transporteur' }
];
/**
 * Entête du tableau dans la section réceptions
 */
const EnhancedTableHead = () => (
  <TableHead>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left">
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

const mapStateToProps = state => ({
  notSentCommandsIds: state.commands.notSentCommandsIds,
  checkedCommandsIds: state.commands.checkedCommandsIds
});

export default connect(mapStateToProps)(EnhancedTableHead);
